import {Component, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Good, Partner} from '@app/shared';
import {getPartnerDisplayName, getSafeImageUrl} from '@app/core';

@Component({
  selector: 'app-avatar-badge',
  standalone: false,

  templateUrl: './avatar-badge.component.html',
  styleUrl: './avatar-badge.component.less'
})
export class AvatarBadgeComponent implements OnChanges {

  @Input() entity: any;
  @Input() urlProperty: string = 'avatar';
  @Input() labelProperties: string[] = ['name', 'surName'];
  @Input() isCurrency = false;
  @Input() label: string = '';

  // Propiedades computadas (se calculan una vez cuando cambian los inputs)
  avatarUrl: string | undefined = undefined;
  initials: string = '';
  hasAvatar: boolean = false;
  displayText: string = '';

  constructor(public el: ElementRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Recalcular propiedades cuando cambian los inputs relevantes
    if (changes['entity'] || changes['urlProperty'] || changes['labelProperties'] || changes['isCurrency']) {
      this.updateComputedProperties();
    }
  }

  private updateComputedProperties(): void {
    if (!this.entity) {
      this.avatarUrl = undefined;
      this.initials = '';
      this.hasAvatar = false;
      this.displayText = '';
      return;
    }

    // Calcular si tiene avatar
    const avatarValue = this.entity[this.urlProperty];
    this.hasAvatar = !!avatarValue;
    
    // Calcular URL del avatar (solo si existe)
    this.avatarUrl = this.hasAvatar ? getSafeImageUrl(avatarValue) : undefined;

    // Calcular iniciales SOLO si no hay avatar
    if (!this.hasAvatar) {
      const displayName = this.getDisplayText();
      const parts = displayName.split(/\s+/).filter(Boolean);
      const calculatedInitials = parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
      this.initials = calculatedInitials || '?';
    } else {
      this.initials = '';
    }

    // Calcular texto de visualización
    this.displayText = this.getDisplayText();
  }

  private getDisplayText(): string {
    if (this.isCurrency) {
      return `${this.entity.name} (${this.entity.isoCode})`;
    }

    if (this.labelProperties[0] === 'name' && this.labelProperties[1] === 'surName') {
      return getPartnerDisplayName(this.entity);
    }

    const parts: string[] = [];
    for (const labelProperty of this.labelProperties) {
      if (this.entity[labelProperty]) {
        parts.push(this.entity[labelProperty]);
      }
    }
    return parts.join(' ');
  }
}
